import mondayClient from './mondayClient';
import mondayServerApi from './mondayServerApi';

class MondayInvoiceService {
  constructor() {
    this.boardId = process.env.REACT_APP_MONDAY_INVOICE_BOARD_ID;
    this.client = mondayClient;
    this.serverApi = mondayServerApi;
  }

  // Use client SDK for frontend operations
  async getContext() {
    return this.client.getContext();
  }

  // Use server API for complex operations
  async createInvoiceItem(invoiceData) {
    const mutation = `
      mutation createItem($boardId: Int!, $itemName: String!, $columnValues: JSON!) {
        create_item(
          board_id: $boardId,
          item_name: $itemName,
          column_values: $columnValues
        ) {
          id
        }
      }
    `;

    const variables = {
      boardId: this.boardId,
      itemName: `Invoice #${invoiceData.invoiceNumber}`,
      columnValues: JSON.stringify({
        status: { label: "Draft" },
        numbers: invoiceData.amount,
        date4: invoiceData.dueDate,
        text: invoiceData.customer.name,
        wave_invoice_id: invoiceData.waveId || ""
      })
    };

    return this.serverApi.request(mutation, variables);
  }

  // Update invoice status in Monday.com
  async updateInvoiceStatus(itemId, status, waveInvoiceId) {
    const mutation = `
      mutation changeColumnValue($boardId: Int!, $itemId: Int!, $columnId: String!, $value: JSON!) {
        change_column_value(
          board_id: $boardId,
          item_id: $itemId,
          column_id: $columnId,
          value: $value
        ) {
          id
        }
      }
    `;

    const variables = {
      boardId: this.boardId,
      itemId: parseInt(itemId),
      columnId: "status",
      value: JSON.stringify({ label: status })
    };

    await this.serverApi.request(mutation, variables);

    // If we have a Wave invoice ID, update that column too
    if (waveInvoiceId) {
      await this.serverApi.request(mutation, {
        ...variables,
        columnId: "wave_invoice_id",
        value: JSON.stringify(waveInvoiceId)
      });
    }
  }

  // Get invoice details from Monday.com
  async getInvoiceDetails(itemId) {
    const query = `
      query getItem($itemId: Int!) {
        items(ids: [$itemId]) {
          id
          name
          column_values {
            id
            title
            text
            value
          }
        }
      }
    `;

    const variables = {
      itemId: parseInt(itemId)
    };

    return this.serverApi.request(query, variables);
  }
}

export default new MondayInvoiceService(); 